import { Injectable, inject } from '@angular/core';
import { ApiService } from './api.service';
import { DashboardOverview, DashboardStats } from '../models/domain.models';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly api = inject(ApiService);

  getStats() {
    return this.api.get<DashboardStats>('/api/dashboard/stats');
  }

  getOverview() {
    return this.api.get<DashboardOverview>('/api/dashboard/overview');
  }
}
